import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { ChartViewTypeEnum, mapValuesFromStringToNumber } from "../helpers";
import { LabelValue } from "../../../../../../types/labelValue";
import StatisticsLayout from "../../../../../../components/statisticsLayout";
import { DonutChart } from "../../../../../../components/charts";
import { requestApi } from "../../../../../../utils/requestApi";
import { POST } from "../../../../../../types/httpMethod";
import { useParams } from "react-router-dom";
import { I18n } from "react-redux-i18n";
import { FilterStatus } from "../../../../../../types/filterStatusValue";

type InteractionsByCategoriesProps = {
  filterStatus: FilterStatus;
};

const InteractionsByCategories: FC<InteractionsByCategoriesProps> = ({ filterStatus }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
      <Chart
        type={ChartViewTypeEnum.DEVICE}
        title={"numberOfInteractionsByCategory"}
        subTitle={"byDeviceType"}
        filterState={filterStatus}
      />
      <Chart type={ChartViewTypeEnum.LANGUAGE} subTitle={"byLanguage"} filterState={filterStatus} />
      <Chart type={ChartViewTypeEnum.MAILING} subTitle={"byDistributionType"} filterState={filterStatus} />
    </div>
  );
};

export default InteractionsByCategories;

type ChartProps = { type: ChartViewTypeEnum; title?: string; subTitle: string; filterState: FilterStatus };

const Chart: FC<ChartProps> = ({ type, title, subTitle, filterState }) => {
  const { data, loading } = useLoadDataByCategory(type, filterState);
  return (
    <StatisticsLayout
      padding={"20px"}
      subTitle={I18n.t(subTitle)}
      title={title ? I18n.t(title) : undefined}
      children={<DonutChart data={data} height={350} loading={loading} />}
    />
  );
};

const useLoadDataByCategory = (type: ChartViewTypeEnum, state: FilterStatus) => {
  const { id: surveyId } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Array<LabelValue>>([]);

  const loadData = useCallback(() => {
    setLoading(true);
    requestApi(POST, "/chart/interactions-by-category", { state: state }, false, false, {}, { surveyId, type })
      .then((res) => setData(mapValuesFromStringToNumber(res)))
      .finally(() => setLoading(false));
  }, [type, surveyId, state]);

  useEffect(() => loadData(), [loadData]);

  return useMemo(() => {
    return { data, loading, reRetch: loadData };
  }, [data, loading]);
};
